<template>
	<v-card :height="$vuetify.breakpoint.smAndDown ? 800 : 770" class="plan premiumPlus"
		:class="currentPlan.tier === SubPlan.PLUS ? 'current-plan' : 'card-border'">
		<v-card-text>
			<div class="text-center plan-header d-flex flex-column align-center justify-end">
				<v-img width="300" aspect-ratio="1" contain src="@/assets/images/mascot/Tier 2.png"></v-img>

				<div class="fs--24 fw--500 mt-3" :class="textColorClass">
					<span>Premium Plus</span>
				</div>
				<p class="fieldFore--text fs--13 fw--500">Push it to the limit</p>
			</div>

			<div class="features mb-3">
				<p class="text-center fw--800 mb-0 offWhite--text">standard tier +</p>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong :class="textColorClass">+{{ cardPlan.customSlots }}</strong>
						Custom Sticker Slots
					</span>
				</div>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong :class="textColorClass">+{{ cardPlan.rewardSlots }}</strong>
						Reward Sticker Slots
					</span>
				</div>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong :class="textColorClass">+{{ cardPlan.ttsVoiceSlots }}</strong>
						Personal TTS Voice Model Slots
					</span>
				</div>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong :class="textColorClass">+{{ cardPlan.ttsStickerSlots }}</strong>
						Personal TTS Sticker Slots
					</span>
				</div>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong :class="textColorClass">+{{ cardPlan.ttsMessageSize }}</strong>
						TTS Message Limit (Total of {{ 256 + cardPlan.ttsMessageSize }} Characters Per TTS Message)
					</span>
				</div>
				<div v-if="cardPlan.customPartyMusic" class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong :class="textColorClass">Personalize</strong>
						Your Sticker Party Music!
					</span>
				</div>
			</div>

			<div class="plan-footer">
				<div class="d-flex flex-column justify-center align-center mb-3">
					<strong v-if="cardPlan.stickerSparkles" class="fs--16 fw--900 text-uppercase mb-3"
						:class="textColorClass">
						+Sticker Sparkles!
					</strong>
					<span class="fs--24 fw--500" :class="textColorClass">Tier 2</span>
					<strong class="shinyPurple--text fs--14 fw--900">Twitch Subscription</strong>
				</div>

				<v-btn v-if="currentPlan.tier === cardPlan.tier" class="plan-btn" color="gray" block depressed>
					Your Current Plan
				</v-btn>
				<v-btn v-else-if="currentPlan.tier < cardPlan.tier" class="plan-btn black--text" color="yellow" block
					depressed @click="actions.subscribe">
					{{ currentPlan.tier === SubPlan.FREE ? 'Subscribe' : 'Upgrade' }}
				</v-btn>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { computed } from '@vue/composition-api';
import store from '@/store';
import { SubPlan } from '@/utils/constants.js';

export default {
	props: {
		subTier: {
			type: Number,
		},
		currentPlan: {
			type: Object,
		},
	},

	setup(props, ctx) {
		const actions = {
			subscribe() {
				ctx.emit('subscribe');
			},
		};

		const cardPlan = computed(() => store.state.app.subPlans.find(p => p.tier === SubPlan.PLUS));

		return {
			SubPlan,
			cardPlan,

			textColorClass: computed(() => (cardPlan.value ? cardPlan.value.primaryColor + '--text' : 'white--text')),

			actions,
		};
	},
};
</script>

<style lang="scss" scoped>
.current-plan {
	border: 1px solid #f2be11 !important;
	box-shadow: 0 0 2px 2px rgba(242, 190, 17, 0.7) !important;
}
</style>
